export const autoCompleteStyles = {
  flex: 1,
  '& .MuiInputBase-root': {
    height: '100%',
  },
  '& .MuiAutocomplete-endAdornment': {
    display: 'none',
  },
  '& .MuiInputBase-input': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
};

export const avatarStyles = {
  width: '16px',
  height: '16.19px',
  mr: 0.5,
  borderRadius: '60.48px',
};

export const containerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.2,
  p: 1,
  borderRadius: '2px',
  backgroundColor: '#F6F8FB',
  width: '130px',
  minWidth: 0,
  maxWidth: '100%',
  height: '32.19px',
  cursor: 'pointer',
  overflow: 'hidden',
  flexShrink: 1,
};

const autoCompleNameStyles = {
  width: '100%',
  '& .MuiInput-root': {
    fontWeight: 400,
    fontSize: { xs: '11px', sm: '12px' },
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
    '&.Mui-focused': {
      color: '#2C5282',
    },
  },
  '& .MuiInput-input': {
    padding: '0px',
    '&::placeholder': {
      fontWeight: 400,
      fontSize: { xs: '11px', sm: '12px' },
      color: '#2C5282',
      opacity: 1,
    },
  },
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  minWidth: 0,
  flexShrink: 1,
};

export const getAutoCompleteNameStyles = (assingeFieldColor?: string) => ({
  ...autoCompleNameStyles,
  '& .MuiInput-input': {
    ...autoCompleNameStyles['& .MuiInput-input'],
    '&::placeholder': {
      ...autoCompleNameStyles['& .MuiInput-input']['&::placeholder'],
      color: `${assingeFieldColor}`,
    },
  },
});

export const nameStyles = {
  fontWeight: 400,
  fontSize: { xs: '11px', sm: '12px' },
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  minWidth: 0,
  flexShrink: 1,
  ml: 0.5,
};

export const scrollContainerStyles = {
  maxHeight: '250px',
  overflowY: 'auto',
  overflowX: 'hidden',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const listItemTextStyles = {
  '& .MuiListItemText-primary': {
    fontSize: '12px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    maxWidth: '100%',
  },
  mr: 1,
};

export const stageDialogStyles = {
  '.MuiDialog-container': {
    alignItems: 'baseline',
    paddingTop: '14.8rem',
  },
  borderRadius: '8px',
};

export const DialogTitleStyle = {
  padding: '2.4rem 2.4rem 0.8rem 2.4rem',
};

export const DialogActionsStyle = {
  mr: 3,
  pb: 3,
  pt: '1.4rem',
};

export const DialogActionButtonStyle = {
  '.MuiButton-root': {
    padding: '0.6rem 1.6rem',
    textTransform: 'uppercase',
    fontWeight: 500,
    lineHeight: '2.4rem',
    letterSpacing: '0.04rem',
    fontSize: '1.4rem',
  },
};
